module.exports = __webpack_public_path__ + "static/media/sensor.467ddd78.svg";